import { Component, Input, OnInit, SimpleChanges } from '@angular/core'; import { ReportdashboardService } from '../../services/reportdashboard.service';
import { ReportsForToday, ReportYear, ReportScheduleForHome } from '../../models/report.model';
import { delay, finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-release-schedule',
  templateUrl: './release-schedule.component.html',
  styleUrls: ['./release-schedule.component.css']
})
export class ReleaseScheduleComponent implements OnInit {
  allReports: ReportScheduleForHome[][] = [];
  selectReport: ReportScheduleForHome[];
  carouselPage: number = 0;
  @Input() releaseScheduleData: ReportScheduleForHome[];

  constructor(private reportDashboardService: ReportdashboardService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.applyReportFileter();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.applyReportFileter();
  }

  applyReportFileter(){
    //var today = new Date();
    if(this.releaseScheduleData != null){      
      for (let i = 0; i < this.releaseScheduleData.length / 5; i++) {
        this.allReports.push(this.releaseScheduleData.slice(i * 5, i * 5 + 5));
      }
      this.allReports = this.allReports.slice(0, this.allReports.length);
      this.selectReport = this.allReports[0];
    }
  }

  updatePage(page) {
    this.carouselPage = page;
    this.selectReport = this.allReports[page];
  }
}
